app.factory("localStorageAccess", function() {
    var _keyName = {
        "user" : "LirFreeApp_UserInfo",
        "medical" : "LirFreeApp_MedicalData",
        "app" : "LirFreeApp_AppData",
        "eatlife" : "LirFreeApp_EatlifeData",
        "balance" : "LirFreeApp_BalanceData",
    };
    return {
        "getData" : function( typeName ) {
            return JSON.parse( localStorage.getItem(_keyName[ typeName ]) );
        },
        "setData" : function( typeName, setData ) {
            localStorage.setItem( _keyName[ typeName ], JSON.stringify(setData) );
        },
        "getSize" : function( typeName ) {
            return JSON.parse( localStorage.getItem(_keyName[ typeName ]) ).length;
        }
	};
});
